// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingNumberSpacesPanel_root__HTl_5","form":"EditListingNumberSpacesPanel_form__3VFsv","title":"EditListingNumberSpacesPanel_title__1j459"};